// extracted by mini-css-extract-plugin
export default {"non-ald-part":"_non-ald-part_4hdKdi","ald-part":"_ald-part_JQE0Tg","prescription-image":"_prescription-image_cFrv+C"};